import IDate from '@dvrd/idate';
import React, {useEffect, useState} from 'react';
import {CalendarEvent, getCalendarDates} from "../../../util/calendarUtil";
import Calendar from "./calendar";

export default function CalendarController() {
    const [startDate, setStartDate] = useState<IDate>(IDate.now().startOf('month'));
    const [endDate, setEndDate] = useState<IDate>(IDate.now().endOf('month'));
    const [events, setEvents] = useState<Array<CalendarEvent>>([]);
    const [loading, setLoading] = useState(false);

    function onNextMonth() {
        if (loading) return;
        const start = startDate.clone().add(1, 'month').startOf('month');
        const end = start.clone().endOf('month');
        _onChangeMonth(start, end);
    }

    function onPrevMonth() {
        if (loading) return;
        const start = startDate.clone().subtract(1, 'month').startOf('month');
        const end = start.clone().endOf('month');
        _onChangeMonth(start, end);
    }

    function onCurrentMonth() {
        if (loading) return;
        const start = IDate.now().startOf('month');
        const end = IDate.now().endOf('month');
        _onChangeMonth(start, end);
    }

    function _onChangeMonth(start: IDate, end: IDate) {
        setStartDate(start);
        setEndDate(end);
        loadEvents(start, end);
    }

    function loadEvents(start: IDate, end: IDate) {
        setLoading(true);
        const [startDate, endDate] = getCalendarDates(start, end);
        CalendarEvent.getEvents(startDate, endDate, (events: Array<CalendarEvent>) => {
            setLoading(false);
            setEvents(events);
        });
    }

    useEffect(() => {
        loadEvents(startDate, endDate);
    }, []);

    return (
        <Calendar onNextMonth={onNextMonth} onPrevMonth={onPrevMonth} onCurrentMonth={onCurrentMonth}
                  startDate={startDate} endDate={endDate} events={events} loading={loading}/>
    );
}